'use client';

import { ContractWrapper } from '@/components/accountSettings/termsAndCondition/TermsAndConditions';
import TermsPreview from './TermsPreview';
import { color, spacing } from '@/theme/tokens';
import { Typography } from '@mui/material';
import { useTranslations } from 'next-intl';
import { privacyPolicyHtml } from './html/privacy-policy-content';
import HTMLDownloadWrapper from '@/components/common/HTMLDownloadWrapper';

export default function PrivacyPolicy() {
    const t = useTranslations('CommonTermsAndConditions');

    // Add the heading to the html content
    const printableHtmlContent = `<h1>${t('privacy.heading')}</h1>${privacyPolicyHtml}`;

    return (
        <>
            <ContractWrapper>
                <Typography
                    variant="heading2bold"
                    color={color.gray[80]}
                    style={{ marginBottom: spacing[32] }}
                    component="h2"
                >
                    {t('privacy.heading')}
                </Typography>
                {/* Compile-time HTML constant from ./html/*.ts — no runtime or user input reaches this sink. */}
                {/* react-doctor-disable-next-line react-doctor/dangerous-html-sink */}
                <TermsPreview dangerouslySetInnerHTML={{ __html: privacyPolicyHtml }} />
            </ContractWrapper>

            <HTMLDownloadWrapper
                filename="W8ShippingPrivacyPolicy"
                downloadButtonText={t('privacy.downloadButtonText')}
                downloadText={t('downloadText')}
                htmlContent={printableHtmlContent}
            />
        </>
    );
}
